import { Link } from "react-router-dom";
import { MapPin, Clock } from "lucide-react";
import { Seo } from "@/components/Seo";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { CtaSection } from "@/components/CtaSection";
import { BAIRROS } from "@/data/bairros";
import { bairroUrl } from "@/lib/routes";
import { breadcrumbSchema, localBusinessSchema } from "@/lib/schema";

export default function BairrosPage() {
  const crumbs = [
    { name: "Início", url: "/" },
    { name: "Bairros Atendidos", url: "/bairros-atendidos" },
  ];
  return (
    <main className="max-w-7xl mx-auto px-4 md:px-8" data-testid="bairros-page">
      <Seo
        title="Bairros Atendidos em Guarulhos | Desentupidora 24 Horas Perto de Você"
        description="Desentupidora 24h nos 10 maiores bairros de Guarulhos: Vila Galvão, Jardim Bom Clima, Jardim Maia, Picanço, Macedo, Taboão, Vila Rio de Janeiro, Cocaia, Ponte Grande e Centro."
        path="/bairros-atendidos"
        jsonLd={[breadcrumbSchema(crumbs), localBusinessSchema()]}
      />
      <Breadcrumbs items={crumbs} />
      <h1 className="font-heading font-black text-3xl sm:text-4xl lg:text-5xl text-brand-dark uppercase tracking-tight py-4">
        Bairros Atendidos em <span className="text-brand-red">Guarulhos</span>
      </h1>
      <p className="text-gray-600 text-sm md:text-base max-w-3xl mb-10">
        Mantemos equipes de plantão 24 horas posicionadas nos 10 maiores bairros de Guarulhos, além de atender os demais bairros do município e a região metropolitana. Clique no seu bairro e veja tempo de chegada, ruas atendidas e avaliações de vizinhos.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 pb-10">
        {BAIRROS.map((b) => (
          <Link key={b.slug} to={bairroUrl(b)} className="group bg-white rounded-xl border border-gray-100 shadow-sm hover:shadow-xl p-6 transition-shadow" data-testid={`bairros-page-card-${b.slug}`}>
            <div className="flex items-center gap-2 mb-2">
              <MapPin size={18} className="text-brand-red" />
              <h2 className="font-heading font-bold text-lg text-brand-dark group-hover:text-brand-red transition-colors">{b.nome}</h2>
            </div>
            <p className="text-gray-500 text-sm line-clamp-3">{b.descricao}</p>
            <span className="inline-flex items-center gap-1.5 mt-4 text-xs font-heading font-bold text-brand-dark bg-brand-yellow px-3 py-1.5 rounded-full">
              <Clock size={13} /> Chegada em {b.tempoChegada}
            </span>
          </Link>
        ))}
      </div>
      <CtaSection titulo="Seu bairro não está na lista?" texto="Atendemos todos os bairros de Guarulhos e região metropolitana. Chame no WhatsApp e confirme o atendimento no seu endereço em segundos." />
    </main>
  );
}
